"use strict";

(function () {
  'use strict';

  angular.module('lr.Properties').factory('formService', formService);
  formService.$inject = ['formFilters', 'propertyFormConstants'];
  /* @ngInject */

  function formService(formFilters, propertyFormConstants) {
    var service = {
      formHelper: formHelper
    };
    return service; ////////////////

    function formHelper(cat, val) {
      var returnValue = {};
      var form = formFilters.getData();

      if (propertyFormConstants[cat]) {
        returnValue = propertyFormConstants[cat];
      }

      if (val._id && val._id === 0) {
        return formFilters.getData();
      }

      return angular.extend({}, form, returnValue);
    }
  }
})();